import styled from 'styled-components';

const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  margin-top: ${({ $noMargin }) => ($noMargin ? '0' : '4px')};
`;

export default MetaRow;
